import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';

export function IconCopy({ classProps }: PropsWithClassProps) {
  return (
    <svg
      className={classProps?.root}
      width="16"
      height="18"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.99487 9.39624C3.99487 6.92715 3.99487 5.69173 4.76232 4.92516C5.52889 4.15771 6.76431 4.15771 9.2334 4.15771H11.8527C14.3218 4.15771 15.5572 4.15771 16.3237 4.92516C17.0912 5.69173 17.0912 6.92715 17.0912 9.39624V13.7617C17.0912 16.2308 17.0912 17.4662 16.3237 18.2328C15.5572 19.0002 14.3218 19.0002 11.8527 19.0002H9.2334C6.76431 19.0002 5.52889 19.0002 4.76232 18.2328C3.99487 17.4662 3.99487 16.2308 3.99487 13.7617V9.39624Z"
        stroke="currentColor"
        strokeWidth="1.72527"
      />
      <path
        d="M3.5282 15.8425C2.83353 15.8425 2.16731 15.5665 1.6761 15.0753C1.18489 14.5841 0.908936 13.9179 0.908936 13.2232V7.9847C0.908936 4.69229 0.908935 3.04564 1.93219 2.02326C2.95458 1 4.60122 1 7.89364 1H11.386C12.0807 1 12.7469 1.27596 13.2381 1.76716C13.7293 2.25837 14.0052 2.92459 14.0052 3.61926"
        stroke="currentColor"
        strokeWidth="1.72527"
      />
    </svg>
  );
}
